import { Messages } from '../../../../codegen/Localize';
import { getSessionManagementServiceInstance } from '../../../../sessionManagement/SessionManagementService';
import { ToasterService, ToastType } from '../../../../ts/services/ToasterService';

/**
 * This is called after all registered forms resolve their submit promises successfully
 */
export async function coordinatorSubmitHandler() {
  // Pop the toast depending on results
  ToasterService.instance.pop({type: ToastType.Success, text: Messages.settingsUpdateSuccess()});

  // Refresh session info as some data may have changed after saving settings
  await getSessionManagementServiceInstance().refreshSessionInfo();
}

/**
 * If a subform throws an array, assume each entry is a message for a new error toast message.
 * Otherwise show a generic error message
 * @param error - An error message or an array of error messages
 */
export async function coordinatorSubmitFailedHandler(error: any) {

  if (Array.isArray(error)) {
    error.forEach(errorMessage => ToasterService.instance.pop({
        type: ToastType.Error,
        text: errorMessage,
      },
    ));
  } else {
    ToasterService.instance.pop({type: ToastType.Error, text: Messages.settingsUpdateFailure()});
  }
}
